import { ChangeDetectionStrategy, Component, inject, input, signal } from '@angular/core';
import { faAngleDown, faAngleUp } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'rcp-list-group-expandable',
  styleUrls: ['./list-group-expandable.component.scss'],
  template: `
    <div class="list-group">
      <div [class.expandable]="expandable()" class="list-group__header" (click)="expand()">
        <rcp-side-nav-item class="list-group__header__label" [label]="label()" [isHeader]="true">
          @if (expandable()) {
            <fa-icon [icon]="expanded() ? faAngleUp : faAngleDown"></fa-icon>
          }
        </rcp-side-nav-item>
      </div>
    </div>
    <div [class.expanded]="expanded() || !expandable()" class="list-group__items">
      <ng-content></ng-content>
    </div>
  `,
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ListGroupExpandableComponent {
  label = input<string>();
  expandable = input<boolean>(true);
  expanded = signal<boolean>(true);

  private parentComponent = inject(ListGroupExpandableComponent, {
    skipSelf: true,
    optional: true,
  });

  expand() {
    if (this.expandable()) {
      this.expanded.set(!this.expanded());
    }
  }

  expandByChild() {
    this.expanded.set(true);
    if (this.parentComponent) {
      this.parentComponent.expandByChild();
    }
  }

  protected readonly faAngleUp = faAngleUp;
  protected readonly faAngleDown = faAngleDown;
}
